import React, {Component} from 'react'
import './index2.less';
import OrderFileComponent from "../../components/bus/order-file";

export default class KtOrderFile extends Component {    constructor(props) {
    super(props);
    this.state = {
        orderId:"",
    }
}
    componentDidMount() {
        if(this.props.location.state) {
            let orderId = this.props.location.state.orderId;
            this.setState({
                orderId
            })
        }
    }
    render() {
        return (
            <OrderFileComponent orderId={this.state.orderId} {...this.props} objectType={"ktFile"}/>
        )
    }
}